import React from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../../components/layout/Layout";
import BookComparisonLab from "../../../components/pages/books/BookComparisonLab";
import { SectionTitle } from "@multiagentbook/ui";
import { ToolsNav } from "../../../components/pages/nav";

const AIAgentBooksPage: React.FC = () => {
  const { t } = useTranslation("aiAgentBooks");

  const siteMetadata = {
    description: t("meta.description"),
    title: t("meta.title"),
    author: "Victor Dibia",
    image: "/images/og-card.png",
    keywords:
      "AI agents books, multi-agent systems book, LLM books, generative AI books, best AI books 2025, agent frameworks",
    twitterUsername: "@designingwithml",
  };

  const breadcrumbPages = [
    { name: t("common:nav.labs"), href: "/labs", current: false },
    { name: t("page.breadcrumb"), href: "/labs/ai-agent-books", current: true },
  ];

  return (
    <Layout
      meta={siteMetadata}
      title={t("page.title")}
      link="/labs/ai-agent-books"
    >
      <main>
        {/* Breadcrumbs */}
        <ToolsNav pages={breadcrumbPages} />

        {/* Hero Section */}
        <div className="mb-8 mt-6">
          <SectionTitle title={t("page.title")} />
          <p className="text-lg text-secondary mt-2 max-w-3xl">
            {t("page.subtitle")}
          </p>
        </div>

        {/* Main Comparison Component */}
        <BookComparisonLab />
      </main>
    </Layout>
  );
};

export default AIAgentBooksPage;
